import React from "react";
import HeroTitle from "../HeroTitle";
import Link from "next/link";
import Image from "next/image";
import { ArrowRightCircle } from "lucide-react";
import { BlockProps } from "../BlocksManager/registry";

const profileColors = [
  "bg-pink text-white",
  "bg-blue text-white",
  "bg-violet text-white",
];

export default function HeroConcept({ data }: BlockProps) {
  if (!data) return null;

  const imageUrl = data?.image?.url;
  const profilCible = data?.profilsCibles || [];

  return (
    <section
      className="overflow-hidden bg-violet-semi-light pl-6 py-10 lg:py-0 "
      key={data.id}
    > 
      <div className="mx-auto grid w-full 3xl:min-h-[700px] 2xl:min-h-[600px] grid-cols-1 lg:grid-cols-2 ">
        {/* Colonne gauche */}
        <div className="relative z-10 flex flex-col justify-center md:px-8 lg:px-12">
          <HeroTitle title={data.titre} />

          <p className="mt-5 max-w-200 font-body text-[18px] font-medium leading-snug text-text-body md:text-[28px]">
            {data?.description}
          </p>

          <div className="mt-5 lg:mt-10">
            <Link
              href={data?.cta?.link || "#"}
              className="inline-flex items-center gap-3 rounded-full bg-yellow px-7 py-3 lg:py-4 text-[18px] font-semibold text-black transition hover:opacity-90"
            >
              {data?.cta?.text}
              <ArrowRightCircle className="h-6 w-6" />
            </Link>
          </div>

          {/* Boutons profils dans le même axe */}
          <div className="mt-5 lg:mt-10 flex flex-wrap items-center gap-4">
            {profilCible.map((profil: any, index: number) => {
              const colorClass = profileColors[index % profileColors.length];

              return (
                <Link
                  key={profil.id}
                  href={profil.link || "#"}
                  className={`inline-flex items-center rounded-full px-6 py-3 text-[16px] font-semibold transition hover:opacity-90 ${colorClass}`}
                >
                  {profil.text}
                </Link>
              );
            })}
          </div>
        </div>

        {/* Colonne droite — image */}
       
        <div className="relative  hidden lg:block">
          {imageUrl && (
            <Image
              src={imageUrl}
              alt="image Concept"
              fill
              className="object-contain object-bottom"
              priority
            />
          )}
        </div>
      </div>
    </section>
  );
}